/** @format */

import ChevronLeftIcon from '@heroicons/react/outline/ChevronLeftIcon'
import * as Tooltip from '@radix-ui/react-tooltip'
import React, {FC, PropsWithChildren} from 'react'
import {Link} from 'react-router-dom'

const Sidebar: FC<
  PropsWithChildren<{
    background?: string
  }>
> = ({background = 'bg-white', children}) => {
  return (
    <div
      className={`col-span-1 hidden border-r border-gray-100 md:block ${background}`}
    >
      <div className={'sticky top-0 max-h-screen overflow-y-auto'}>
        {children}
      </div>
    </div>
  )
}

const Main: FC<PropsWithChildren> = ({children}) => {
  return (
    <div
      className="col-span-full grid overflow-hidden md:col-span-1"
      style={{gridTemplateRows: 'auto auto 1fr auto'}}
    >
      {children}
    </div>
  )
}

const PageHeader: FC<
  PropsWithChildren<{
    title?: string
    background?: string
  }>
> = ({title, background = 'bg-white', children}) => {
  return (
    <div className={`border-b border-gray-100 ${background}`}>
      <Link
        to={'/forms'}
        className={'primaryLink flex items-center px-2 pt-6 sm:px-8 md:hidden'}
      >
        <ChevronLeftIcon className={'inline h-5'} /> Forms
      </Link>
      <h1 className={`px-2 py-6 text-2xl font-bold text-secondary sm:px-8`}>
        {title}
      </h1>
      {children}
    </div>
  )
}

const Content: FC<PropsWithChildren> = ({children}) => {
  return <div className="overflow-x-auto bg-gray-50">{children}</div>
}

const Footer: FC<
  PropsWithChildren<{
    background?: string
  }>
> = ({background = 'bg-white', children}) => {
  return (
    <div className={`border-t border-gray-100 ${background}`}>
      <footer>{children}</footer>
    </div>
  )
}

const DashboardLayout: FC<
  PropsWithChildren<{
    background?: string
  }>
> & {
  Sidebar: typeof Sidebar
  Main: typeof Main
  PageHeader: typeof PageHeader
  Content: typeof Content
  Footer: typeof Footer
} = ({background = 'bg-gray-50', children}) => {
  return (
    <Tooltip.Provider delayDuration={360}>
      <div
        className={`grid min-h-screen border-t border-gray-100 ${background}`}
        style={{gridTemplateColumns: '300px 1fr'}}
      >
        {children}
      </div>
    </Tooltip.Provider>
  )
}

DashboardLayout.Sidebar = Sidebar
DashboardLayout.Main = Main
DashboardLayout.PageHeader = PageHeader
DashboardLayout.Content = Content
DashboardLayout.Footer = Footer
export default DashboardLayout
